import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';

import styles from './styles';

class NotAuthorized extends Component {
  static propTypes = {
  };

  state = {
  };

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.body}>
          <div><img alt="Staza" src="/images/logo.png"/></div>
          <div><FontIcon className="material-icons" style={styles.icon}>visibility_off</FontIcon></div>
          <div style={styles.text}>Not authorized</div>
          <div><RaisedButton secondary label="Logout" fullWidth onClick={() => this.props.push('/logout')}/></div>
        </div>
      </div>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    push,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotAuthorized);



// WEBPACK FOOTER //
// ./src/components/Authentication/NotAuthorized/index.js